module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-21.3ec4d154.png";